module.exports = __webpack_public_path__ + "static/media/minneapolis-tablet.8041d9f2.webp";